import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../components/tables/tableContext/TableContext";
import { AwbHistoryDataInterface } from "../../../../redux/interfaces/expedition.interface";
import { getDateAndTime } from "../../../../utils/dateAndTime";

export const packagesColdFilter = [
  { value: 0, label: "Toate" },
  { value: 1, label: "Colete" },
  { value: 2, label: "Colete frig" },
  { value: 3, label: "Paleti" },
];

export const awbHistoryTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "",
    value: "selected",
    minW: 125,
  },
  {
    label: "Nr. expeditie",
    value: "doc_trans",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Client",
    value: "client",
    minW: 125,
  },
  {
    label: "Pct. preluare",
    value: "pctpreluare",
    minW: 125,
  },
  {
    label: "Pct. livrare",
    value: "pctlivrare",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Adresa",
    value: "adresa",
    minW: 125,
  },
  {
    label: "Nod-Destinatie",
    value: "nodDestinatie",
    minW: 125,
  },
  {
    label: "Ruta/Ruta transferata",
    value: "route",
    minW: 125,
  },
  {
    label: "Status",
    value: "status",
    minW: 125,
  },
  {
    label: "Tip colete",
    value: "coldFilter",
    minW: 125,
    withFilter: packagesColdFilter,
  },
  {
    label: "Data crearii",
    value: "data_crearii",
    minW: 125,
    withDatePicker: {
      maxDate: new Date(),
      withClearData: true,
    },
  },
];

export const getAwbTableData = (data: AwbHistoryDataInterface[]): TableData[] =>
  data.map((item) => {
    const deliveredStatusValidation = item.status === 10;
    const isColdBox = item.tip_colete.some((tip) => tip.tip_ambalaj === 75);

    const coldBoxStyle = {
      color: isColdBox ? "#90D5FF" : "black",
    };

    return {
      id: item.id_doctrans,
      crudData: item,
      data: [
        {
          checkbox: {
            id: item.id_doctrans,
            isSelected: false,
            isHidden: deliveredStatusValidation,
          },
        },
        {
          title: item.doc_trans,
          titleStyle: coldBoxStyle,
        },
        {
          title: item.client,
        },
        {
          title: item.pctpreluare,
        },
        {
          title: item.pctlivrare,
        },
        {
          title: item.adresa,
        },
        {
          title: item.nodDestinatie,
        },
        {
          badges: [
            {
              badgeText: item.ruta,
              badgeColor: "light-info",
            },
            {
              badgeText: item.rutaTransferata ?? "-",
              badgeColor: "light-success",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.denumireStatus ?? "-",
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: item.tip_colete.map((tip) => {
            return {
              badgeText: `${tip.denumire} x ${tip.count_tip_ambalaj}`,
              badgeColor: "primary",
            };
          }),
        },
        {
          badges: [
            {
              badgeText: item.data_crearii
                ? getDateAndTime(item.data_crearii)
                : "-",
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
